import { API_V2 } from "@/config/api";
import { Branding } from "@/types/models/Branding";
import apiRequest from "./api";

export const routes = {
  update: `${API_V2}/branding/main`,
  get: `${API_V2}/branding/main`,
};

export const updateBranding = (input: Partial<Branding>) =>
  apiRequest<Branding>(routes.update, {
    method: "POST",
    data: input,
  });
